export const CHART_TYPE = {
   BAR_CHART: 'barChart',
   LINE_CHART: 'lineChart',
   PIE_CHART: 'pieChart',
   BAR_CHART_STACKED_GROUPED: 'barChartGroupedStacked',
};
